export var ClientSharedValues = {
  lstatSync: function lstatSync() {}
};